/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Button, TextField, Grid, Typography } from '@mui/material';
import * as validation from '../../shared/validation';
import columnDefs from '../../column-defs';
import '../../styles/forgot-password.scss';
import { ro } from '../../shared/assets/images';
import HeaderSection from '../header-section';

const Forgot = () => {
  const [authData, setAuthData] = useState({});

  // validation layer start
  const [touchedFields, setTouchedFields] = useState({});
  const { schema } = columnDefs.forgotpassword.forms;
  const { email } = authData;
  const errors = validation.validation({
    schema,
    data: {
      email,
    },
  });
  const handleBlur = (e) => {
    const { name, id } = e.target;
    setTouchedFields({
      ...touchedFields,
      [name || id]: true,
    });
  };
  const validationDiv = (field) =>
    validation.errorDiv(errors, touchedFields, field);
  // validation layer end

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAuthData({ ...authData, [name]: value });
  };

  return (
    <div style={{ height: innerHeight }}>
      <div style={{ backgroundColor: 'white', height: '3px' }} />
      <div style={{ backgroundColor: '#F2F2F2', height: innerHeight - 15 }}>
        <HeaderSection />
        <div style={{ backgroundColor: 'white' }}>
          <Grid container spacing={2} style={{ marginTop: '0px', height: innerHeight - 75, alignItems: 'center' }}>
            <Grid item xs={6} style={{ paddingTop: '0px' }}>
              <Grid container spacing={2} style={{ marginLeft: '15%' }}>
                <Grid item xs={12}>
                  <h2 style={{ color: '#00AEC7' }} className="rufusBld">Forgot Password</h2>
                  <div style={{ display: 'flex', marginTop: '2%', color: '#5C5A6C' }} >
                    <Typography variant='caption' className="sansW4SeLig" gutterBottom>Enter your email to receive an mail to reset your password</Typography>
                  </div>
                </Grid>
                <Grid item xs={8} style={{ paddingTop: '4%' }} className="rufusReg f14">
                  Email Id*
                  <TextField
                    id="outlined-basic"
                    margin="normal"
                    fullWidth
                    name="email"
                    variant="outlined"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={email}
                    type="text"
                    size="small"
                    required
                    className='bordered-input-box'
                    disabled
                    data-testid="email-input"
                  />
                  <div style={{ textAlign: 'left' }}>{validationDiv('email')}</div>
                </Grid>
                <Grid item xs={8} style={{ marginTop: '2%', color: '#333333' }}>
                  <p className="sansW4SeLig">
                    Already have account?<a href="/sign-in" className="login-link sansW6SeBld">Log in</a></p>
                </Grid>

                <Grid item xs={8}>
                  <Button variant="contained" data-testid="button" className="button-reset sansW6SeBld " fullWidth
                    onClick={handleSubmit} disabled>Send</Button>
                </Grid>

                <Grid item xs={8}>
                  <Typography
                    variant="body2"
                    align="center"
                    className="all-rights sansW4SeLig">
                    ©2022 Winflows Design Simulator cloud next All rights reserved
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ paddingTop: '0px' }}>
              <img align='right' src={ro} style={{ marginRight: '9%', width: '80%' }} alt="rosystem" />
            </Grid>
          </Grid>
        </div>

      </div>
    </div>
  );
};
export default Forgot;
